import { createAxiosCancelable } from '@hmhco/core-network/src/axiosHelpers';
import requestHelper from '@hmhco/core-network/src/utils/requestHelper';
import { getIdentifiedPlatformConfig } from '@hmhco/login-config';

const requestSignInDetailsUrl = `/ids/v1/users/signin-notification`;
const requestSignInDetailsUrlHnm = `/ids/v1/users/signin-notification`;
const requestSignInDetailsUrlNwea = `/ids/v1/users/signin-notification`;

export default (pactConfig = {}) => {
  const { client, cancel, cancelToken, isCancel } = createAxiosCancelable({
    includeAuth: false,
  });
  const request = requestHelper({
    client,
    cancelToken,
    isCancel,
    baseURL: getIdentifiedPlatformConfig().hcpIdentityApiGateway,
    pactConfig,
  });
  return {
    requestSignInDetailsEd: ({ email, districtId, orgRefId }) =>
      request.post(
        requestSignInDetailsUrl,
        JSON.stringify({ email, districtId, platform: 'Ed', orgRefId }),
        {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        },
      ),
    cancel,
    requestSignInDetailsHnm: ({ email, districtId, orgRefId }) =>
      request.post(
        requestSignInDetailsUrlHnm,
        JSON.stringify({ email, districtId, platform: 'Hnm', orgRefId }),
        {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        },
      ),
    requestSignInDetailsNwea: ({ email, districtId, orgRefId }) =>
      request.post(
        requestSignInDetailsUrlNwea,
        JSON.stringify({ email, districtId, platform: 'nwea', orgRefId }),
        {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        },
      ),
  };
};
